module.exports = __webpack_public_path__ + "img/4_24.e96cd512.png";